import { Container, IDestroyOptions } from "@pixi/display";
import { PlayerModel } from "../../../models/player/PlayerModel";
import { TextStyle } from "@pixi/text";
import { Sprite } from "@pixi/sprite";
import { Texture } from "@pixi/core";
import { GameModel } from "../../../models/game/GameModel";
import { AnimatedScore } from "../../../../common/components/AnimatedScore";
import { getDefaultFontFamily } from "../../../../common/TextUtils";

export class ScoreView extends Container {
    private movesSubstrate: Sprite;
    private coverageSubstrate: Sprite;
    private animatedScore: AnimatedScore;
    private animatedCoverage: AnimatedScore;

    public constructor(
        substrateTexture: Texture,
        private readonly gameModel: GameModel,
        private readonly playerModel: PlayerModel
    ) {
        super();
        this.movesSubstrate = this.addChild(new Sprite(substrateTexture));
        this.animatedScore = new AnimatedScore(this.playerModel.Score, new ScoreTextStyle());
        this.animatedScore.position.set(this.movesSubstrate.width * 0.5, 8);
        this.movesSubstrate.addChild(this.animatedScore);

        this.coverageSubstrate = this.addChild(new Sprite(substrateTexture));
        this.coverageSubstrate.position.x = this.movesSubstrate.position.x + this.movesSubstrate.width + 50;
        this.animatedCoverage = new AnimatedScore(this.gameModel.countFieldCoverage(), new ScoreTextStyle(), true);
        this.animatedCoverage.position.set(this.coverageSubstrate.width * 0.5, 8);
        this.coverageSubstrate.addChild(this.animatedCoverage);

        this.playerModel.onChanged.add(this.redrawScore, this);
        this.redrawScore();
    }

    private redrawScore(): void {
        this.animatedScore.updateScore(this.playerModel.Score);
        this.animatedCoverage.updateScore(this.gameModel.countFieldCoverage());
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.playerModel.onChanged.remove(this.redrawScore, this);
        super.destroy(options);
    }
}

class ScoreTextStyle extends TextStyle {
    constructor() {
        super({
            fontFamily: getDefaultFontFamily(),
            fontSize: 54,
            fill: 0xFFFFFF,
            stroke: 0x243988,
            strokeThickness: 4,
            lineJoin: "round",
            align: "center"
        });
    }
}